module.exports = __webpack_public_path__ + "img/qr.5bc14ba6.png";